//#region types
import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion

function usePausedPaymentsService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getTotalSelectedPaymentsAmount = (selectedPayments: WintSuperkollAPIModel.PausedPayment[]) => {
    let totalAmount = 0;
    selectedPayments.forEach((payment) => {
      totalAmount += payment.amount ?? 0;
    });
    return totalAmount;
  };

  const getPausedPayments = () => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .TodoClient.Get({
        types: [WintSuperkollAPIModel.TodoType.PausedPayments],
        page: 0,
        orderByDescending: false,
        thenByDescending: false,
        isAutoPaginating: false,
      })
      .then((res) => (res.data.items ? res.data.items[0] : null))
      .then((res) => (res?.pausedPayments ? res.pausedPayments : null));
  };

  const resumePausedPayments = (invoicesToResume: number[]) => {
    const incomingInvoiceClient = apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).IncomingInvoiceClient;
    return Promise.all(invoicesToResume.map((id) => incomingInvoiceClient.ResumePayment(id)));
  };

  return { getTotalSelectedPaymentsAmount, getPausedPayments, resumePausedPayments };
}

export default usePausedPaymentsService;
